import Header from './Components/Header';
import Public from './Routes/Public';
import Footer from './Components/Footer';
import './App.css';
import {
  BrowserRouter as Router
} from "react-router-dom"
import { useState } from 'react';
import uk from './Img/uk.png'

function App() {

  const [language, setLanguage] = useState(uk);

  return (
    <div className="App">
      <Router>
        <Header language={language} setLanguage={setLanguage} uk={uk} />
        <Public language={language} uk={uk} />
        <Footer language={language} uk={uk} />
      </Router>
    </div>
  );

}

export default App;
